<app-default-progress-bar *ngIf="showProgressBar()"></app-default-progress-bar>

<table [dataSource]="lanesDataTable" class="mat-elevation-z1" mat-table matSort style="width: 100%">
	<ng-container matColumnDef="origin">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<mat-icon class="primary-light-color">place</mat-icon>
			<span class="fs-13 color-black">Origin</span>
		</th>
		<td *matCellDef="let element" mat-cell>{{ element.origin }}</td>
	</ng-container>

	<ng-container matColumnDef="destination">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<mat-icon class="primary-light-color">place</mat-icon>
			<span class="fs-13 color-black">Destination</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<span *ngIf="!utilService.isNullOrUndefined(element.destination)">{{
				element.destination
			}}</span>
		</td>
	</ng-container>

	<ng-container matColumnDef="equipment">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<mat-icon class="primary-light-color">local_shipping</mat-icon>
			<span class="fs-13 color-black">Equipment</span>
		</th>
		<td *matCellDef="let element" mat-cell>{{ element.equipment }}</td>
	</ng-container>

	<ng-container matColumnDef="frequency">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<mat-icon class="primary-light-color">date_range</mat-icon>
			<span class="fs-13 color-black">Frequency</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			{{ !utilService.isNullOrUndefined(element.frequency) ? element.frequency : '' }}
			{{
				!utilService.isNullOrUndefined(element.frequency) &&
				utilService.isValidNumber(element.frequency)
					? '/ weekly'
					: ''
			}}
		</td>
	</ng-container>

	<ng-container matColumnDef="partial">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<mat-icon class="primary-light-color">local_shipping</mat-icon>
			<span class="fs-13 color-black">Partial</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<span>
				<mat-checkbox [(ngModel)]="element.ltl" [disabled]="true"> </mat-checkbox>
			</span>
		</td>
	</ng-container>

	<ng-container matColumnDef="lastMatch">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<mat-icon class="primary-light-color">calendar_today</mat-icon>
			<span class="fs-13 color-black">Last Match</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<span>
				{{ element.lastMatch ? (element.lastMatch | date: 'MM/dd/yyyy') : 'N/A' }}
			</span>
		</td>
	</ng-container>

	<ng-container matColumnDef="rateUpdatedAt">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<mat-icon class="primary-light-color">calendar_today</mat-icon>
			<span class="fs-13 color-black">Last Booked</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<span>
				{{ element.rateUpdatedAt ? (element.rateUpdatedAt | date: 'MM/dd/yyyy') : 'N/A' }}
			</span>
		</td>
	</ng-container>

	<ng-container matColumnDef="mostRecentActivity">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<mat-icon class="primary-light-color">local_activity</mat-icon>
			<span class="fs-13 color-black">Most Recent Activity</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<div
				*ngIf="!utilService.isNullOrUndefined(element.loadNotBookedReason)"
				fxLayoutAlign="center center"
			>
				{{ element.loadNotBookedReason }}
			</div>
			<div
				*ngIf="!utilService.isNullOrUndefined(element.rating)"
				class="wrapper"
				fxLayoutAlign="center center"
			>
				<ng-rating-bar
					[(value)]="element.rating"
					[disabled]="true"
					[ratingCount]="5"
					class="pointer-events-none"
				>
				</ng-rating-bar>
			</div>
		</td>
	</ng-container>

	<ng-container *ngIf="IS_PRICING_ENABLED" matColumnDef="lastRate">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<mat-icon class="primary-light-color">attach_money</mat-icon>
			<span class="fs-13 color-black">Last Rate</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<span
				*ngIf="!utilService.isNullOrUndefined(element.lastRate)"
				[matTooltip]="rateTooltip(element)"
				matTooltipClass="custom-tooltip"
			>
				{{ element.lastRate | currency: 'USD' : 'symbol' : '1.0-0' }}
			</span>
			<span *ngIf="utilService.isNullOrUndefined(element.lastRate)"> N/A </span>
		</td>
	</ng-container>

	<ng-container matColumnDef="notes">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<mat-icon class="primary-light-color">note</mat-icon>
			<span class="fs-13 color-black">Notes</span>
		</th>
		<td *matCellDef="let element" mat-cell></td>
	</ng-container>

	<ng-container *ngIf="incorrectLaneFeedback" matColumnDef="laneFeedback">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<span class="fs-13 color-black"></span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<mat-icon
				(click)="laneFeedback(element)"
				class="cursor-pointer primary-text"
				fxLayoutAlign="center center"
				>edit
			</mat-icon>
		</td>
	</ng-container>

	<tr *matHeaderRowDef="lanesColumns" mat-header-row></tr>
	<tr
		*matRowDef="let row; columns: lanesColumns"
		(click)="onRowClick(row)"
		class="row-hover"
		mat-row
	></tr>
</table>
<mat-paginator
	(page)="getCarrierLanes(lanePaginator.pageIndex)"
	*ngIf="lanesLength > LANES_PAGE_SIZE"
	[length]="lanesLength"
	[pageSizeOptions]="[LANES_PAGE_SIZE]"
	class="mat-elevation-z1"
	showFirstLastButtons
>
</mat-paginator>
